module.exports = {
    i: '0',
    language: {
        name: '中文',
        logo: "../../static/images/logo_1_en.png"
    },
    user: {
        login: 'login',
        cart: "My Cart",
        Logout: "Logout",
        my_order: "My Order",
        fabrics: "Fabrics",
        fashion:"fashion",
        order: "Order",
        client: "Client",
        material: "Material",
        quick_order: "Quick Order",
        customer_service: "Customer Service",
        delivery_details: "Delivery details",
        cash: "My cash",
        ticket: "Ticket",
        contact: "Contact Us ",
        About: "About Us ",
        account: "Account Center",
        user_name: "user name",
        password: "password",
        log_in: "Log in now",
        temporary: "Temporary account",
        verify: "Click to verify",
        successful: "Validation successful",
        failed: "verification failed",
        log_out: "OK to log out",
        logout_ok: "Logout successful!",
        please_log: "please log in first!",
        please_verification: "Please complete security verification",
        swipe_right: "Swipe right to complete verification",
        please_click: "Please click",
        "请选择": "please choose",
        "请输入内容": "Please enter content",
        "请输入关键词": "Please enter a keyword",
        "已成功加入购物车！": "Has been successfully added to the shopping cart!",
    },
    footer: {
        footer: "all right reserved  2016-2017  Shandong ASPOP E-Business Co.,Ltd",
        site: "Add:NO.188 GENGJIAO RD,HUANTAI CITY,  ZIBO SHANDONG P.R. OF CHINA ",
        phone: "Tel:(0086)-400-6930-777",
        records: "Please use 1366*768 resolution when operate the system"
    },
    home: {
        home: "Home",
        start: "START",
        start_p: "CUSTOM CLOTHING",
        image: "IMAGE",
        image_p: "VISUAL EXPERIENCE",
    },
    verify: {
        phone: "please enter a valid phone number",
        phoneScope: "The format of the mobile phone number is incorrect",
        danhao: "Please enter the correct customer number",
        danhaoScope: "The value contains 10 to 12 characters and can only be letters and numbers",
        fullName: "Please type in your name",
        fullNameScope: "You can only enter 2-5 pure Chinese characters or 2-20 English/characters",
        gender: 'Please select gender',
        height: "Please enter height",
        heightScope: "Input range 50 to 250",
        weight: "Please enter weight",
        weightScope: "Input range 20 to 350",
        measureStaff: "Please enter the scale",
        img_lose: "Picture failed to load",
        scope: "Enter the valid size of ",
        leaving: "Leaving will cause the written content to be lost.",
        not_selected: "This operation will not retain the process information you selected!",
        continue: "Whether to continue?",
        determine: "determine",
        cancel: "cancel",
        been_canceled: "Has been canceled",
        delivery_address: "Please enter the shipping address" ,
        return: "return",
        danhaoMessage: "The customer order number can be used",
        classify: "Please select classify",
        category: "Please select a category",
        style: "Please select a style",
        Fabric_type: "Please select fabric type",
        Fabric_number: "Please select fabric number",
        count: "Please enter the order quantity",
        orderCount: "The minimum order quantity is 1",
        deepDesign: "Please add the selected depth design"
    },
    start: {
        next: "next",
        back: "back",
        design: "Design",
        decoration: "Decoration",
        information: "Information",
        measure: "Measure",
        fabric: 'Fabric Supply',
        editionType: 'editionType',
        craft: 'craft',
        style: "Style",
        category: "Category",
        classify: "Classify",
        fabrics: "Fabrics",
        craftsmanship: "Craftsmanship",
        all: "All",
        name: "Name",
        technologyCode:"TechnologyCode",
        ingredient: "Ingredient",
        // numberOfUnits: 'numberOfUnits',
        numberOfUnits: 'Meters of remaining fabric',
        price: 'price',
        reset: "Reset",
        input: "Please enter content",
        user_input: "User input",
        essential_information: "essential information ",
        username: "Name",
        phone: "Phone",
        stature: "Stature",
        gender: 'gender',
        weight: "Weight",
        surveyor: "Surveyor",
        order_number: "order number",
        receiving_address: "Harvest address",
        search: 'search',
        img: "Diagrammatic Drawing",
        data: "Basic Data",
        dressing: "Dressing Style",
        sizeSelection: 'Size selection',
        scope: "Scope",
        info: "Customer information",
        technique: "Technique information",
        exmbroidery: "Embroidery information",
        is_info: "Essential information",
        category: "Category",
        type: " Type of merchandise",
        supplier: "Supplier",
        fabric: "Fabric",
        save: "save",
        size: "Size information",
        title: "Your customized item has been successfully added to the shopping cart",
        num: "The number of goods in the shopping cart is ",
        preview: "Product Preview",
        order_info: "Order information",
        address: "Customer address",
        email: "Customer email",
        nickname: "Customer nickname",
        price: "Settlement price",
        $: "￥",
        others: "Look at the others",
        accounts: "To settle accounts",
        enter_all: "Please enter all your basic data",
        no_data: "No data available",
        // no_3d: "No 3D data",
        not_selected: "The content is not selected! Please choose the style you like.",
        not_specified: "Please enter first",
        unspecified: "You still have unspecified content",
        conserveSelectCraft: "Please save the selected process first",
        prompt: "Prompt",
        this_style: "This style conflicts in",
        check: ', it is recommended to check it first!',
        style_related: "This style is related to",
        ygl: "",
        related: "Related",
        conflict: "Conflict",
        tjx: "The currently selected item",
        bei: "under the same level is associated with the",
        zhong: "selected in",
        guanlian: "",
        not_choose: "Can't choose!",
        loading_3D: "3D loading failed, please try again！",
        selectFabric: "Please select fabric!",
        "标准号型": "Standard model",
        close: "close",
        conserve: "Preservation technology",
        content: "Please enter content",
        materialDeficiency: "Insufficient fabric stock",
        materialDeficiency2: "Fabric stock will be short",
        negative: "Fabrics with a negative value cannot be selected",
        negativeProduct: "The current product price is negative, please choose another product",
        negativeTechnology: "The current process price is negative, please choose another process",
        sequence: "Please select in group order",
        prompt: "Prompt",
        confirm: "confirm",
        cancel: "cancel",
        selectTechnology: "Have selected the same type of process, do you want to replace?",
        notarize: "confirmation message",
        conserve: "conserve",
        waive: "Abandon modification"
    },
    image: {
        new_product: "New product launch",
        new_explain: "The new products are on Monday and Thursday",
        More: "More new products",
        popular: "Popular recommendation",
        designer: "Recommended by designer",
        recommend: "More recommendations",
        hot: "Hot selling goods",
        products: "More products",
        everybody: "Everybody's watching",
        times: "Purchase times",
        sales: "sales",
        cycle: "production cycle",
        category:"production category",
        days: "days",
        component: "component",
        fabric: "Fabric number",
        style: "Style number",
        customized: "Fabric selection",
        tailor: "Personalized",
        measure: "To measure",
        homologous: "Homologous hot products",
        details: "Details",
        commodity: "Commodity style",
        whole: "whole",
        price: "Price",
        floor: "floor price",
        ceiling: "ceiling price",
        search: "Search",
        keywords: "Please enter keywords",
        peakPriceMessage: "Please enter the highest price",
        bottomPriceMessage: "Please enter the lowest price"
    },
    measure: {
        self: "Self-Measurement",
        standard: "Standard Size",
        selected: "Self-Selected",
        Refer: "Refer to Video",
        "cm": "cm",
        "kg": "kg"
    },
    cart: {
        courier_information: "Courier information",
        order: "order number",
        keywords: "Please enter keywords such as",
        not_submitted: "Not pre-submitted",
        audit: "pre-submitted",
        failure: "Audit failure",
        picture: "Product picture",
        date: "Add date",
        number: "number",
        price: "price",
        emergency: 'emergency or not',
        status: "Order status",
        operation: "operation",
        again: "Buy again",
        edit: "edit",
        submission: "Pre submission",
        delete: "Delete order",
        export: "Export list",
        export_order: "Export order",
        total: "Total merchandise",
        total_price: "Total price",
        pay: "To pay",
        confirm: "confirm",
        payment: "Please select payment method",
        balance: "Payment with balance",
        available: "Available balance",
        payment_type: '"Self design order" and "micro customization order" cannot be paid at the same time, please check the selected order',
        statu: "The selected order has data that failed to be approved or not submitted in advance",
        select: "Please select an order",
        delete_order: "Please select the order you want to delete",
        export_details: "Please select the order for which you want to export details",
        successful: "Payment successful",
        need_pay: "Need to pay",
        balance: "Balance",
        alipay: "Alipay",
        WeChat: "WeChat",
        account_balance: "Account Balance",
        confirm_payment: "Confirm payment",
        please_alipay: "Please scan the 2D code with Alipay",
        scanning_phone: "Scanning successfully, please operate on your phone",
        Please_WeChat: "Please use WeChat to scan the 2D code",
        withdraw_balance: "Withdraw balance",
        actual_name: "actual name",
        please_name: "please enter your real name",
        select_payment: "Please select the payment method",
        buyNum: "The number of purchases must not be less than 1",
        maxNum: "The maximum quantity cannot be greater than 10,000",
        pdStaues: "No payment can be made without pre-submission",
        orders: "Cannot pay for multiple orders",
        adresseeInfo: "Please select a delivery address",
        negative: "Orders with a zero or negative price cannot be paid"
    },
    fabrics: {
        status: "Fabric status",
        no_deactivated: "Not deactivated",
        deactivated: "Deactivated",
        serial: "Number",
        number: "Fabric number",
        series: "Series",
        attribute: 'Attribute',
        decor: "Decor",
        colour: 'Colour',
        gauze: "Gauze",
        stop: "Out of service"
    },
    material: {
        price: "Unit price",
        details: "Order details",
        quantity: "Purchase quantity",
        inventory: "Inventory",
        jian: "",
        buy: "Buy now",
        material_search: "Please enter the material name to search",
        add_cart: "add to Shopping Cart",
    },
    myClient: {
        add_info: "Add customer information",
        number: "Number",
        customer: "Name",
        nickname: "Nickname",
        height: "Height",
        weight: "Body weight",
        phone: "Phone",
        mailbox: "Mailbox",
        operating: "Operating",
        edit: "Edit",
        delete: "Delete",
        info: "Customer information",
        customer_number: "Customer order number",
        area: "Area",
        detailed_area: "Detailed area",
        remarks: "Remarks",
        determine: "Determine",
        gender: 'Customer gender',
        fullNameMessage: "Please fill in the customer name",
        nickNameMessage: "Please fill in the customer nickname",
        genderMessage: "Please fill in gender",
        addressMessage: "Please fill in the address information",
        heightMessage: "Please fill in height",
        weightMessage: "Please fill in your weight",
        phoneMessage: "Please fill in your mobile phone number",
        phoneVerifyMessage: "The format of the mobile phone number is incorrect"
    },
    order: {
        recharge_method: "Recharge method",
        want_amount: "Please enter the amount you want to withdraw",
        withdrawal_amount: "Withdrawal Amount",
        enter_account: "Please enter the account to be reflected",
        account: "Withdrawal account",
        withdrawal_method: "Withdrawal method",
        client_name: "Client company name",
        account_name: "account name",
        transaction_item: "Transaction item",
        transaction_date: "Transaction date",
        expenditure: "Expenditure",
        income: "Income",
        statement: "Statement",
        recharge: "Recharge",
        please_amount: "Amount",
        current_balance: "Current account balance",
        please: "Please enter the tracking number",
        order_details: "order details",
        express_delivery: "express delivery",
        tracking_number: "Tracking number",
        courier_company: "Courier company",
        delivery_date: "delivery time",
        logistics_number: "Logistics number",
        shipping_settings: "Shipping settings",
        add_delivery_address: "Add Address",
        under_review: "Under review",
        time: "Order time",
        end: "End Time",
        start:'Start Time',
        transaction: "Transaction hour",
        daizhifu:"unpaid",
        daishenhe:"to be reviewed",
        daishengchan:"to be produced",
        all: "All",
        made: "Plate made",
        unpay:"to be paid",
        production: "In production",
        apply: "Apply for shipment",
        shipped: "Shipped",
        cancel: "Cancel order",
        export_list: "Export list",
        export_details: "Export details",
        number: 'Number',
        single_num: "Single number",
        name: "Name",
        accountName: 'Account name',
        material: 'Fabric name',
        order_date: "Order date",
        delivery_date2: "estimated time of delivery",
        delivery: "Delivery date",
        amount: "order amount",
        num: "number",
        order_status: "Order Status",
        operating: "Operating",
        buy_again: "Buy again",
        batch: "Batch application for shipment",
        paid: "Paid",
        push: "Push failure",
        info: "Customer information",
        is_info: "Essential information",
        order_number: "order number",
        username: "Name",
        phone: "Phone",
        address: "Customer address",
        email: "Customer email",
        nickname: "Customer nickname",
        category: "Category",
        type: " Type of merchandise",
        supplier: "Supplier",
        fabric: 'Fabric Supply',
        size: "Size information",
        formula: "Price formula",
        technique: "Technique information",
        exmbroidery: "Embroidery information",
        choose_date: "Choose date and time",
        select_address: "Select address",
        add_address: "add new address",
        set_Default: "set as Default",
        edit: "edit",
        delete: "Delete",
        include_order: "Include order",
        add_order: "Add order",
        chosen: "Chosen",
        orders: "orders",
        receiver: "Receiver",
        address: "Address",
        contact: "Contact information",
        back_list: "Back to list",
        delivery_success: "Application for delivery successfully",
        picture: "Product picture",
        fabric: "Fabric",
        confirm: "confirm",
        fail: "cause of failure"
    },
    quick: {
        product_info: "product information",
        gender: "Gender",
        category: "Category",
        style: "Style",
        pattern: "pattern",
        mailyardTechnology: "technology",
        fabric_type: "Fabric type",
        fabric: "Fabric number",
        order_number: "order number",
        quantity_order: "quantity of order",
        technique: "Technique information",
        info: "Customer information",
        phone: "Phone",
        usernameusername: "Name",
        height: "Height",
        weight: "Body weight",
        username: "Customer Name",
        surveyor: "Surveyor",
        self: "Self-Measurement",
        Refer: "Refer to Video",
        selected: "Self-Selected",
        standard: "Standard Size",
        data: "Basic Data",
        scope: "Scope",
        dress_style: "Dress style",
        schematic: "Schematic diagram",
        size_selection: "Size selection",
        add_cart: "add to Shopping Cart",
        client: "My client",
        design: "Depth design",
        selectInfo: "Select my customer information",
        craftCode: "Please select process"
    },
    invoice: {
        order_number: "Order number/Customer order number",
        return: "Return",
        consequences: "If our company fails to apply for issuance or use of special value-added tax invoices in accordance with relevant national regulations, our company shall bear the corresponding legal consequences.",
        know: "I have fully understood the above-mentioned relevant national tax laws and invoice management regulations, and confirmed that I only request invoices for the actual purchase of goods or services by our company.",
        require2: "(2) Although there is a purchase of goods or taxable services, but requiring others to issue a special value-added tax invoice whose quantity or amount does not match the actual situation], otherwise it is a 'false special value-added tax invoice.'",
        require1: "(1) Asking others to issue special VAT invoices for themselves without purchasing goods or receiving taxable services;",
        require: "According to the national tax law and relevant regulations on invoice management, no unit or individual shall require others to issue special value-added tax invoices for themselves that are inconsistent with actual business conditions [including but not limited to",
        VAT: "Confirmation for issuance of special VAT invoices",
        authorization: "Ticket increase authorization letter template download",
        upload_attorney: "Upload power of attorney for ticket increase",
        click_upload: "Click upload",
        notice: "All uploaded files must be stamped with an official seal. The supported image format is jpg/jpeg/png. Be sure to upload clear photos. A single image must be less than 10M. If there is a problem with the upload button, please install the Flash plugin.",
        upload_files: "Upload qualification files",
        cancel: "Cancel",
        determine: "Determine",
        confirmation_qualification: "《Confirmation of Ticket Increase Qualification》",
        read_agree: "I have read and agree",
        all_required: "(All information is required)",
        fill_info: "Fill in the ticket increase qualification information",
        attorney_increase: "Power of Attorney for Ticket Increase",
        taxpayer_certificate: "General taxpayer certificate",
        registration_copy: "Tax registration copy",
        bank_account: "Bank Account",
        bank_deposit: "bank of deposit",
        register_phone: "Register phone",
        registered_address: "Registered address",
        taxpaye_code: "Taxpayer identification code",
        company_name: "Company name",
        increase_info: "Increase ticket qualification information",
        delete: "Delete",
        modify: "Modify",
        complement_invoicing: "Complement invoicing",
        ticket_qualification: "Increase ticket qualification",
        shipping_address: "Shipping address",
        qualification_increase: "Your qualification for ticket increase",
        not_added: "Not added",
        add: "Add ticket increase qualification",
        amount_goods: "The amount of goods",
        "发票状态": "Invoice status",
        "操作": "operating",
        "开具发票": "Invoice",
        "发票类型": "Invoice type",
        "普通发票": "Ordinary invoice",
        "增值税发票": "VAT invoice",
        "发票名称": "Issuance name",
        "纳税人识别号": "Taxpayer Identification Number",
        "注册地址": "Registered address",
        "注册电话": "Registered phone",
        "银行账户": "Bank Account",
        "开户银行": "bank of deposit",
        "所需价格": "Price required",
        "收货地址": "Shipping address",
        "收货人": "Receiver",
        "所在地区": "Area",
        "地址": "Address",
        "手机": "Phone",
        "固定电话": "Fixed telephone",
        "固定电话": "Mailbox",
        "确认并提交": "Confirm and submit",
        "请输入订单号/客户单号/面料号/客户姓名等关键字": "Please enter the order number/customer order number/fabric number/customer name and other keywords",
        "请填写名称": "Please fill in the name",
        "纳税人识别号位数限制为15到20位": "The taxpayer identification number is limited to 15 to 20 digits",
        "注册地址必须包含汉字": "Registered address must contain Chinese characters",
        "电话格式不正确": "Incorrect phone format",
        "开户银行必须包含汉字": "Bank account must contain Chinese characters",
        "银行账号只能是数字": "Bank account numbers can only be numbers",
        "提交成功": "Submitted successfully",
        "您未具有开具增值税发票的资质": "You are not qualified to issue VAT invoices",
        "已支付": "Paid",
        "已制版": "Plate made",
        "生产中": "In production",
        "已发货": "Shipped",
        "撤单": "Cancel",
        "未申请": "Not applied",
        "已申请": "Already applied",
        "待审核": "in review",
        "审核驳回": "rejection",
        "审核通过": "Approved",
        "请选择发票类型": "Please select invoice type",
        "下一步": "Next",
        "上一步": "Previous",
        "请确认商品价格以及收货地址": "Please confirm the product price and shipping address",
        "价格": "price",
        "名称": "Name",
        "收货地址": "Shipping address",
        "必填": "Required",
        "纳税人识别码": "Taxpayer identification code",
        "注册地址": "Registered address",
        "注册电话": "Register phone",
        "新增收货地址": "New shipping address",
        "您已创建": "You have created",
        "个收货地址,最多可创建": "addresses, you can create up to",
        "个": "addresses",
        "默认地址": "default address",
        "设为默认": "set as Default",
        "编辑": "edit",
        "最多添加20个发票地址": "Add up to 20 invoice addresses",
        "邮箱": "Mailbox",
        "添加收货地址": "Add shipping address",
        "详细地址": "Address",
        "手机号码": "mobile phone number",
        "或": "or",
        "固定电话": "Fixed telephone",
        "地址别名": "Address alias",
        "建议填写常用名称": "It is recommended to fill in the common name",
        "家里": "Home",
        "父母家": "Parent's home",
        "公司": "work phone",
        "保存收货地址": "Save the shipping address",
        consigneeMessage: 'The consignee cannot be empty',
        areaMessage: 'The province or city of the region cannot be empty',
        addressMessage: 'The detailed address cannot be empty',
        phoneMessage: 'The phone number cannot be empty',
    }
}



// WEBPACK FOOTER //
// ./src/components/language/en.js